
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insta-repair",
      function () {
        return require("private-next-pages/insta-repair/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insta-repair"])
      });
    }
  